import { Box, Flex, xcss } from '@atlaskit/primitives'
import { media } from '@atlaskit/primitives/responsive'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'
import analytics from '../services/analytics'

const headerStyles = {
  self: xcss({ backgroundColor: 'color.skeleton' }),
  wrapper: xcss({
    padding: '0 20px',
    height: 72,
    margin: 'auto',
    maxWidth: 1160,
    [media.below.sm]: { justifyContent: 'center' },
  }),
}

export default function Header() {
  const data = useStaticQuery(graphql`
    {
      file(relativePath: { eq: "atlassian-logo.png" }) {
        childImageSharp {
          gatsbyImageData(width: 190, placeholder: NONE, layout: FIXED)
        }
      }
    }
  `)

  return (
    <Box className='page-header' xcss={headerStyles.self}>
      <Flex alignItems='center' xcss={headerStyles.wrapper}>
        <Flex as='a' href='https://atlassian.com' rel='noreferrer' target='_blank'>
          <GatsbyImage
            alt='Atlassian logo'
            image={getImage(data.file)}
            onClick={() => analytics.events.atlLinkClick('logo')}
          />
        </Flex>
      </Flex>
    </Box>
  )
}
